export const SOLUTION_STATE = {
	ASSIGN: 1,
	RELEASE: 2,
	PROGRESS: 601,
};
